// ABOUTME: Dropdown arrow icon component pointing downward
// ABOUTME: Supports className, size, and color customization

interface ChevronDownIconProps {
  className?: string
  size?: number
  color?: string
}

export const ChevronDownIcon = ({ className = "", size = 20, color = "currentColor" }: ChevronDownIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill={color}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
    />
  </svg>
)
